import { ReactElement, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'

import Snackbar from 'components/Snackbar'

interface ISuccessNotificationProps {
  onClose: () => void
}

export const SuccessNotification = ({ onClose }: ISuccessNotificationProps): ReactElement => {
  useEffect(() => {
    setTimeout(() => {
      onClose()
    }, 5 * 1000)
  }, [onClose])

  return (
    <Snackbar.Container>
      <Snackbar.Content>
        <FormattedMessage id="partnerCost.new.success.message" defaultMessage="Cost saved successfully." />
      </Snackbar.Content>
      <Snackbar.Action onClick={onClose}>
        <FormattedMessage id="partnerCost.new.success.action" defaultMessage="Close" />
      </Snackbar.Action>
    </Snackbar.Container>
  )
}
